import { StateCreator } from 'zustand';
import { Markdown, FileSummary } from '../types';

export interface OtherSlice {
  // Markdown management
  markdowns: Markdown[];
  addMarkdown: (id: string, name: string, content: string) => void;
  updateMarkdown: (id: string, updates: Partial<Markdown>) => void;
  deleteMarkdown: (id: string) => void;

  // Summary management
  summaries: FileSummary[];
  addSummary: (summary: FileSummary) => void;
  updateSummary: (id: string, updates: Partial<FileSummary>) => void;
  deleteSummary: (id: string) => void;

  // Sidebar management
  sidebarWidth: number;
  setSidebarWidth: (width: number) => void;
}

export const createOtherSlice: StateCreator<OtherSlice> = (set) => ({
  // Markdown state
  markdowns: [],
  addMarkdown: (id, name, content) =>
    set((state) => ({
      markdowns: [...state.markdowns, { id, name, content, lastModified: Date.now() }],
    })),
  updateMarkdown: (id, updates) =>
    set((state) => ({
      markdowns: state.markdowns.map((m) => (m.id === id ? { ...m, ...updates } : m)),
    })),
  deleteMarkdown: (id) =>
    set((state) => ({
      markdowns: state.markdowns.filter((m) => m.id !== id),
    })),

  // Summary state
  summaries: [],
  addSummary: (summary) =>
    set((state) => ({
      summaries: [...state.summaries, summary],
    })),
  updateSummary: (id, updates) =>
    set((state) => ({
      summaries: state.summaries.map((s) => (s.id === id ? { ...s, ...updates } : s)),
    })),
  deleteSummary: (id) =>
    set((state) => ({
      summaries: state.summaries.filter((s) => s.id !== id),
    })),

  // Sidebar state
  sidebarWidth: 250,
  setSidebarWidth: (width) => set({ sidebarWidth: width }),
});

